import { API_METHODS, createApiFunction } from './apiProvider'

const PATH = 'photo-bank'

export const savePhotoBankApi = (photoBank) =>
  createApiFunction(API_METHODS.POST, PATH, { photos: photoBank }, true)
